export const Icon = `
    <IconArrowRight/>
`